import {
  ArrowUDownLeftIcon,
  ChartLineIcon,
  ClipboardTextIcon,
  CoinsIcon,
  GearIcon,
  HouseIcon,
  PackageIcon,
  SquaresFourIcon,
  TrendUpIcon,
} from '@phosphor-icons/react'

import { subscriptionPlans, userPermissions } from '@/common/constants'
import routes from '@/Router/routes.constants'

export const getOptions = ({
  analyticsUrl,
  subscriptionPlan,
  hasPermission,
  allowInventory,
  allowPerformanceInsights,
  allowsUnifiedDashboard,
}) => [
  {
    Icon: HouseIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: routes.merchantDashboardPage,
    label: 'Inicio',
    visible: allowsUnifiedDashboard,
    isMerchantOption: true,
  },
  {
    Icon: ArrowUDownLeftIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: `${routes.merchantTransactionsPage}?returnsCursor=null`,
    label: 'Transacciones',
    visible: allowsUnifiedDashboard,
    isMerchantOption: true,
  },
  {
    Icon: GearIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: `${routes.merchantConfigurationPage.index}`,
    label: 'Configuración global',
    visible: allowsUnifiedDashboard,
    isMerchantOption: true,
  },
  {
    Icon: SquaresFourIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: routes.dashboardPage,
    label: 'Dashboard',
    visible: true,
    isMerchantOption: false,
  },
  {
    Icon: ArrowUDownLeftIcon,
    iconWeights: {
      default: 'light',
      selected: 'bold',
    },
    link: `${routes.transactionsPage}?returnsCursor=null`,
    label: 'Transacciones',
    visible: true,
    isMerchantOption: false,
  },
  {
    Icon: PackageIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: `${routes.parcelsPage.index}?shipmentsCursor=null`,
    label: 'Envíos',
    visible: true,
  },
  {
    Icon: ClipboardTextIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: routes.inventoryPage.index,
    label: 'Inventario',
    visible: allowInventory && hasPermission(userPermissions.viewShipmentsInventory),
  },
  {
    Icon: ChartLineIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: routes.analyticsPage,
    label: 'Métricas',
    visible: analyticsUrl !== null && hasPermission(userPermissions.viewMetrics),
    isMerchantOption: false,
  },
  {
    Icon: TrendUpIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: routes.performanceInsights,
    label: 'Performance Insights',
    visible: allowPerformanceInsights && hasPermission(userPermissions.viewMetrics),
    isMerchantOption: false,
  },
  {
    Icon: CoinsIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: routes.billingPage,
    label: 'Facturas',
    visible: subscriptionPlan !== subscriptionPlans.basic && hasPermission(userPermissions.viewBilling),
    isMerchantOption: false,
  },
  {
    Icon: GearIcon,
    iconWeights: {
      default: 'light',
      selected: 'fill',
    },
    link: hasPermission(userPermissions.viewStore) ? routes.configurationPage.store : routes.configurationPage.index,
    label: 'Configuración',
    visible: true,
    isMerchantOption: false,
  },
]
